import { HTTP } from "../helpers/http-common.js";
import authHeader from "../helpers/auth-header.js";

const monitoringService = {
  getLogFiles,
  getLogs
};

export default monitoringService;

function getLogFiles() {
  return HTTP.get("admin/log-files", {
    headers: {
      Authorization: authHeader()
    }
  });
}

function getLogs(params = {}) {
  return HTTP.get("admin/logs", {
    params: {
      file: params.file || "",
      lines: params.lines || 200,
      level: params.level || "",
      search: params.search || ""
    },
    headers: {
      Authorization: authHeader()
    }
  });
}
